/**
 * Created by Sale on 10/28/2024
 */
import {Role} from "@/utils/utils";
import dataValidationPage from "@/modules/data-validation-module/views/data-validation-page.vue";

const Module = () => import("./Module.vue");

const moduleRoute = {
    path: "/data-validation",
    component: Module,
    children: [
        {
            path: '/',
            name: 'data-validation',
            meta: {
                product: 'Realite Admin',
                title: 'Data Validation',
                isSubCategory: false,
                roles: [Role.ADMIN, Role.TRAFFIC_ENG],
                permission:'event-validation:get-report',
                topBarTitle: '',
                menuPriority: 9,
                hasMenu: true,
                hasInternalTransition: false,
                menuGroup: 'Data',
                menuGroupPriority: 3
            },
            component: dataValidationPage
        },
/*        {
            path: '/video-calibration/:projectId?/:dataDeviceId?',
            name: 'video-calibration',
            meta: {
                product: 'Realite Admin',
                title: 'Video Calibration',
                isSubCategory: true,
                roles: [Role.ADMIN, Role.TRAFFIC_ENG],
                permission:'data-processing:list-video-calibrations',
                topBarTitle: 'Video Calibration',
                menuPriority: 6,
                hasMenu: true,
                hasInternalTransition: false
            },
            props: true,
            component: videoCalibrationPage
        },
        {
            path: '/auto-validation-review/:projectId?/:dataDeviceId?/:dataType?',
            name: 'auto-validation-review',
            meta: {
                product: 'Realite Admin',
                title: 'Auto Validation Review',
                isSubCategory: true,
                roles: [Role.ADMIN, Role.TRAFFIC_ENG],
                permission:'data-processing:get-report',
                topBarTitle: 'Auto Validation Review',
                menuPriority: 6,
                hasMenu: true,
                hasInternalTransition: false
            },
            props: true,
            component: autoValidationReviewPage
        },
        {
            path: '/import-data-validation/:projectId?/:dataDeviceId?',
            name: 'import-data-validation',
            meta: {
                product: 'Realite Admin',
                title: 'Import Data Validation',
                isSubCategory: true,
                roles: [Role.ADMIN, Role.TRAFFIC_ENG],
                permission:'data-processing:get-report',
                topBarTitle: 'Import Data Validation',
                menuPriority: 6,
                hasMenu: true,
                hasInternalTransition: false
            },
            props: true,
            component: importDataValidationPage
        },*/
    ]
};

export default router => {
    router.addRoutes([moduleRoute]);
};
